import { ArrowUp } from "lucide-react";

import { Shell } from "@/components/wizard/shell";

export function SendScreen({
	accept,
	onAcceptChange,
	hp,
	onHpChange,
	onBack,
	onSubmit,
	pending,
}: {
	accept: boolean;
	onAcceptChange: (v: boolean) => void;
	hp: string;
	onHpChange: (v: string) => void;
	onBack: () => void;
	onSubmit: () => void;
	pending: boolean;
}) {
	return (
		<Shell>
			<button
				type="button"
				onClick={onBack}
				className="absolute left-6 top-6 -m-3 flex items-center gap-2 p-3 text-base text-muted-foreground hover:text-foreground sm:-m-0 sm:gap-1 sm:p-0 sm:text-sm"
			>
				<ArrowUp className="size-4" />
				voltar
			</button>

			<div className="fade-up w-full max-w-xl text-center">
				<h1 className="font-display text-4xl leading-tight text-foreground">
					Tudo pronto pra enviar
				</h1>
				<p className="mt-4 text-xl text-muted-foreground">
					É só confirmar e a gente recebe o seu cadastro na hora.
				</p>

				<label className="mt-10 flex cursor-pointer items-start gap-3 rounded-xl border-2 border-foreground/15 bg-card p-5 text-left">
					<input
						type="checkbox"
						checked={accept}
						onChange={(e) => onAcceptChange(e.target.checked)}
						className="mt-1 size-5 accent-info"
					/>
					<span className="text-lg text-foreground">
						Aceito receber novidades e promoções da clínica no WhatsApp e e-mail
					</span>
				</label>

				<input
					type="text"
					value={hp}
					onChange={(e) => onHpChange(e.target.value)}
					tabIndex={-1}
					autoComplete="off"
					aria-hidden="true"
					className="sr-only"
				/>

				<button
					type="button"
					onClick={onSubmit}
					disabled={pending}
					className="mt-10 w-full rounded-full bg-primary px-10 py-4 text-xl font-semibold text-primary-foreground shadow-control transition hover:bg-primary-hover disabled:opacity-60"
				>
					{pending && "Enviando..."}
					{!pending && "Enviar cadastro"}
				</button>
			</div>
		</Shell>
	);
}
